import { render } from "./StepImproveUserinfo.vue?vue&type=template&id=c1827efc"
import script from "./StepImproveUserinfo.vue?vue&type=script&lang=js"
export * from "./StepImproveUserinfo.vue?vue&type=script&lang=js"

import "./StepImproveUserinfo.vue?vue&type=style&index=0&id=c1827efc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__